import { apiRequestToken } from '../Utilidades/apiRequest';

export const postAdjunto = async (formData: FormData) => {
    return apiRequestToken({
        endpoint: 'files',
        body: formData,
        method: 'POST',
        multi_part: true,
    })
};